import { channels, ENVS as sharedEnvs } from 'shared/constants';

export const ENVS = sharedEnvs;

export const getEnvByHostname = (hostname: string) => {
  if (
    !hostname ||
    hostname === 'localhost' ||
    hostname.startsWith('192.168') ||
    hostname.includes('feature.builds.')
  ) {
    return ENVS.TEST;
  }

  const apiTemplate = 'https://{domain}.sessionstudio.com';
  const webTemplate = 'https://{domain}.sessionstudio.com/studio';
  const [, , ...subdomains] = hostname.split('.').reverse();
  const webDomain = subdomains.reverse().join('.');
  const apiDomain = webDomain.replace('app', 'api');

  const getEnvName = () => {
    if (hostname.includes('.test.')) {
      return ENVS.TEST.NAME;
    }

    if (hostname.includes('.qa.')) {
      return ENVS.QA.NAME;
    }

    return ENVS.PROD.NAME;
  };

  return {
    API: apiTemplate.replace('{domain}', apiDomain),
    WEB: webTemplate.replace('{domain}', webDomain),
    NAME: getEnvName(),
  };
};

const getElectronEnv = () => {
  const { api } = window;
  const electronConfig = api.sendSync(channels.GET_ELECTRON_CONFIG);
  if (electronConfig?.env === 'qa') {
    return ENVS.QA;
  }
  if (electronConfig?.env === 'prod') {
    return ENVS.PROD;
  }
  return ENVS.TEST;
};

export const getEnv = () => {
  switch (process.env.REACT_APP_BUILD_TARGET) {
    case 'electron': {
      return getElectronEnv();
    }
    case 'web': {
      return getEnvByHostname(window.location.hostname);
    }
    default:
      return ENVS.TEST;
  }
};

const sessionAssistHost = 'localhost:51463';
const configValues = {
  all: {
    appVersion: process.env.REACT_APP_VERSION,
    env: process.env.NODE_ENV || 'development',
    isElectronBuild: process.env.REACT_APP_BUILD_TARGET !== 'web',
    isFeatureBuild: process.env.REACT_APP_BUILD_TYPE === 'feature',
    publicUrl: process.env.PUBLIC_URL,
    basename: '/studio',
    baseUrl: 'http://localhost:3023',
    sessionAssistBaseUrl: `http://${sessionAssistHost}`,
    sessionAssistBaseWs: `ws://${sessionAssistHost}`,
    sessionApiBaseUrl: getEnv().API,
    sessionWebDomain: getEnv().WEB,
    APPSFLYER_WEB_APP_TEST_ID: 'fade7149-a1c9-4e3f-9a1c-e996952dc6a7',
    APPSFLYER_WEB_APP_PROD_ID: 'ff7d88a6-ba12-40ba-b2cb-b98d579492ad',
    GTM: {
      ID: 'GTM-NT6TBZ5',
      DEV_PREVIEW: '11',
      DEV_AUTH: 'Jb-x1BmH6WUZiXYRhj6fdw',
    },
  },
  production: {},
};

export const config = {
  ...configValues.all,
  // @ts-ignore
  ...configValues[configValues.all.env],
};
